export const BID_MANAGER_UPDATE = "bid_manager_update";
export const BID_MANAGER_UPDATE_SUCCESS = "bid_manager_update_success";
export const BID_MANAGER_UPDATE_FAIL = "bid_manager_update_fail";
